import { forwardRef } from 'react';

import { cx } from 'cva';

import styles from './panel.module.css';

export type PanelContentProps = React.PropsWithChildren<
  React.HTMLAttributes<HTMLDivElement>
>;

/**
 * PanelContent - scrollable body region of a Panel.
 */
export const PanelContent = forwardRef<HTMLDivElement, PanelContentProps>(
  ({ className, children, ...rest }, ref) => {
    const classes = cx([styles.panel_content, className]);
    return (
      <div ref={ref} className={classes} {...rest}>
        {children}
      </div>
    );
  },
);
